<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="100px" :rules="rules">


				<el-row>
					<el-col :span="24">
						<el-form-item label="推送类型" prop="thejobtype">
							<select-option-dictionary v-model="formParameter.thejobtype"
								dkey="ts-type"></select-option-dictionary>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="推送方式" prop="method">
							<select-option-dictionary v-model="formParameter.method"
								dkey="ts-method"></select-option-dictionary>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="是否自动推送" prop="isauto">
							<el-switch v-model="isauto" active-color="#13ce66" inactive-color="#ff4949">
							</el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="isauto">
						<el-form-item label="推送时间" prop="chetime">
							<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" placeholder="不选默认立即推送"
								v-model="formParameter.chetime" type="datetime" align="right" rule="rules">
							</el-date-picker>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="内容" prop="content">
							<el-input type="textarea" row="3" v-model="formParameter.content"
								autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>


				<el-row>
					<el-col :span="24">
						<el-form-item label="推送名单" prop="sid">
							<el-table :data="studentList" style="width: 100%">
								<el-table-column prop="studentName" label="姓名" width="100">
								</el-table-column>
								<el-table-column prop="sid" label="学生ID" width="280">
								</el-table-column>
							</el-table>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/tuisong.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			valuex: '',  //站位
			stuList: [],   //会员备选列表
			isauto: true, //是否自动推送
			studentList: [],
			rules: {
				//内容
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				chetime: [
					{
						validator: this.checkChetime,
						trigger: 'blur'
					}
				]

			}
		};
	},
	methods: {
		checkChetime(rule, value, callback) {
			const currentTimestamp = Date.now();
			const selectedTimestamp = new Date(value).getTime();

			if (selectedTimestamp < currentTimestamp) {
				callback(new Error('警告：选定时间早于当前时间'));
			} else {
				callback();
			}
		},
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
			this.studentList = []
			this.studentList.push(...this.parameter)
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {


			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				this.formParameter.isauto = this.isauto ? 1 : 0;
				let saveData = []
				for (let i = 0; i < this.studentList.length; i++) {
					saveData.push({
						...this.studentList[i],
						...this.formParameter
					})
				}
				// let parameter = this.$utils.merger(saveData);
				api.pushSaves(saveData,
					response => {
						this.$utils.msg.success(response.msg);
						this.confirmLoading = false;
						this.close()
					},
				);
			});
		},
		init() {
			// //this.popupLoading = true;
			// //清除等待
			// //this.confirmLoading = false;
			// //清空内容
			// this.formParameter = 
			// { 
			// 	thejobtype: '作业' ,
			// 	method: '邮箱'
			// }
			// //清楚校验
			// this.$refs.form.clearValidate();
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			this.valuex = [];
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.isauto = response.data.isauto == 1;
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
